import { all, put, takeLatest } from "redux-saga/effects";

import store from "../../store/store";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import SettingsService from "../../services/SettingsService";
import OrderStatusService from "../../services/OrderStatusService";
import {
  componentKey,
  getDataImport,
  setAdminUsersList,
  setCloseAddCodeDialog,
  setCloseAddDrugDialog,
  setCloseAddTemplateDialog,
  setCloseAddUserDialog,
  setCodeList,
  appendCodeList,
  setCloseDataImportData,
  setDrugList,
  setTemplateList,
  setTemplateNameOptions,
  setRolesResponsibilityList,
  setCloseAddRolesResponsibilityDialog,
  getAdminUserProfileData,
  setCloseAdminUserProfileData,
  setCommunicationRulesList,
  setCommunicationRuleById,
  setCloseAddCommunicationRuleDialog,
  setOrderStatusList,
  setCloseAddOrderStatusDialog,
  setTemplateImportResults,
  setOpenTemplateImportResultsDialog,
  setMasterRoleCreated,
  setMasterRoleList,
  setCloseMasterRoleDialog,
  setMasterDataList,
  setCloseMasterDataDialog,
  setOrderTypeList,
  setCloseAddOrderTypeDialog,
} from "./SettingsSlice";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";

export const {
  getDrugList,
  postDrugData,
  patchDrugData,
  deleteDrug,
  getCodeList,
  postCodeData,
  patchCodeData,
  deleteCode,
  getTemplateList,
  getTemplateNameOptions,
  postTemplateData,
  patchTemplateData,
  uploadTemplateData,
  postUserData,
  getAdminUsers,
  patchAdminUsersData,
  deleteAdminUser,
  sendAdminUserInvitation,
  sendAdminUserBulkInvitation,
  getDataImportList,
  postDataImport,
  patchDataImport,
  getProfileData,
  patchProfileData,
  getRolesResponsibilityList,
  postRolesResponsibilityData,
  patchRolesResponsibilityData,
  deleteRolesResponsibility,
  postMasterRoleData,
  patchMasterRoleData,
  deleteMasterRole,
  getMasterRoleList,
  getMasterDataList,
  postMasterData,
  patchMasterData,
  deleteMasterData,
  getOrderTypeList,
  postOrderTypeData,
  patchOrderTypeData,
  deleteOrderType,
  getCommunicationRules,
  createCommunicationRule,
  getCommunicationRuleById,
  updateCommunicationRule,
  deleteCommunicationRule,
  getOrderStatusList,
  postOrderStatus,
  patchOrderStatus,
  deleteOrderStatus,
  postTaskType,
  patchTaskType,
  deleteTaskType,
} = {
  getDrugList: (payload) => {
    return {
      type: "SETTINGS/GET_DRUG_LIST",
      payload,
    };
  },
  postDrugData: (payload) => {
    return {
      type: "SETTINGS/POST_DRUG_DATA",
      payload,
    };
  },
  patchDrugData: (payload) => {
    return {
      type: "SETTINGS/PATCH_DRUG_DATA",
      payload,
    };
  },
  deleteDrug: (payload) => {
    return {
      type: "SETTINGS/DELETE_DRUG_DATA",
      payload,
    };
  },
  getCodeList: (payload) => {
    return {
      type: "SETTINGS/GET_CODE_LIST",
      payload,
    };
  },
  postCodeData: (payload) => {
    return {
      type: "SETTINGS/POST_CODE_DATA",
      payload,
    };
  },
  patchCodeData: (payload) => {
    return {
      type: "SETTINGS/PATCH_CODE_DATA",
      payload,
    };
  },
  deleteCode: (payload) => {
    return {
      type: "SETTINGS/DELETE_CODE_DATA",
      payload,
    };
  },
  getTemplateList: (payload) => {
    return {
      type: "SETTINGS/GET_TEMPLATE_LIST",
      payload,
    };
  },
  getTemplateNameOptions: (payload) => {
    return {
      type: "SETTINGS/GET_TEMPLATE_NAME_OPTIONS",
      payload,
    };
  },
  postTemplateData: (payload) => {
    return {
      type: "SETTINGS/POST_TEMPLATE_DATA",
      payload,
    };
  },
  patchTemplateData: (payload) => {
    return {
      type: "SETTINGS/PATCH_TEMPLATE_DATA",
      payload,
    };
  },
  uploadTemplateData: (payload) => {
    return {
      type: "SETTINGS/UPLOAD_TEMPLATE_DATA",
      payload,
    };
  },
  postUserData: (payload) => {
    return {
      type: "SETTING/POST_USER_DATA",
      payload,
    };
  },
  getAdminUsers: (payload) => {
    return {
      type: "SETTING/GET_USER_DATA",
      payload,
    };
  },
  patchAdminUsersData: (payload) => {
    return {
      type: "SETTING/PATCH_USER_DATA",
      payload,
    };
  },
  deleteAdminUser: (payload) => {
    return {
      type: "SETTING/DELETE_USER_DATA",
      payload,
    };
  },
  sendAdminUserInvitation: (payload) => {
    return {
      type: "SETTING/SEND_ADMIN_USER_INVITATION",
      payload,
    };
  },
  sendAdminUserBulkInvitation: (payload) => {
    return {
      type: "SETTING/SEND_ADMIN_USER_BULK_INVITATION",
      payload,
    };
  },
  getDataImportList: (payload) => {
    return {
      type: "SETTING/GET_DATA-IMPORT_DATA",
      payload,
    };
  },
  postDataImport: (payload) => {
    return {
      type: "SETTING/POST_DATA-IMPORT_DATA",
      payload,
    };
  },
  patchDataImport: (payload) => {
    return {
      type: "SETTING/PATCH_DATA-IMPORT_DATA",
      payload,
    };
  },
  getRolesResponsibilityList: (payload) => {
    return {
      type: "SETTINGS/GET_ROLES_AND_RESPONSIBILITY_LIST",
      payload,
    };
  },

  postRolesResponsibilityData: (payload) => {
    return {
      type: "SETTINGS/POST_ROLES_AND_RESPONSIBILITY_DATA",
      payload,
    };
  },

  patchRolesResponsibilityData: (payload) => {
    return {
      type: "SETTINGS/PATCH_ROLES_AND_RESPONSIBILITY_DATA",
      payload,
    };
  },

  deleteRolesResponsibility: (payload) => {
    return {
      type: "SETTINGS/DELETE_ROLES_AND_RESPONSIBILITY_DATA",
      payload,
    };
  },
  postMasterRoleData: (payload) => {
    return {
      type: "SETTINGS/POST_MASTER_ROLE_DATA",
      payload,
    };
  },
  patchMasterRoleData: (payload) => {
    return {
      type: "SETTINGS/PATCH_MASTER_ROLE_DATA",
      payload,
    };
  },
  deleteMasterRole: (payload) => {
    return {
      type: "SETTINGS/DELETE_MASTER_ROLE",
      payload,
    };
  },
  getMasterRoleList: (payload) => {
    return {
      type: "SETTINGS/GET_MASTER_ROLE_LIST",
      payload,
    };
  },
  getMasterDataList: (payload) => {
    return {
      type: "SETTINGS/GET_MASTER_DATA_LIST",
      payload,
    };
  },
  postMasterData: (payload) => {
    return {
      type: "SETTINGS/POST_MASTER_DATA",
      payload,
    };
  },
  patchMasterData: (payload) => {
    return {
      type: "SETTINGS/PATCH_MASTER_DATA",
      payload,
    };
  },
  deleteMasterData: (payload) => {
    return {
      type: "SETTINGS/DELETE_MASTER_DATA",
      payload,
    };
  },
  getOrderTypeList: (payload) => {
    return {
      type: "SETTINGS/GET_ORDER_TYPE_LIST",
      payload,
    };
  },
  postOrderTypeData: (payload) => {
    return {
      type: "SETTINGS/POST_ORDER_TYPE_DATA",
      payload,
    };
  },
  patchOrderTypeData: (payload) => {
    return {
      type: "SETTINGS/PATCH_ORDER_TYPE_DATA",
      payload,
    };
  },
  deleteOrderType: (payload) => {
    return {
      type: "SETTINGS/DELETE_ORDER_TYPE_DATA",
      payload,
    };
  },
  getProfileData: (payload) => {
    return {
      type: "SETTING/GET_USER_PROFILE_DATA",
      payload,
    };
  },
  patchProfileData: (payload) => {
    return {
      type: "SETTING/PATCH_USER_PROFILE_DATA",
      payload,
    };
  },
  getCommunicationRules: (payload) => {
    return {
      type: "SETTINGS/GET_COMMUNICATION_RULES",
      payload,
    };
  },
  createCommunicationRule: (payload) => {
    return {
      type: "SETTINGS/CREATE_COMMUNICATION_RULE",
      payload,
    };
  },
  getCommunicationRuleById: (payload) => {
    return {
      type: "SETTINGS/GET_COMMUNICATION_RULE_BY_ID",
      payload,
    };
  },
  updateCommunicationRule: (payload) => {
    return {
      type: "SETTINGS/UPDATE_COMMUNICATION_RULE",
      payload,
    };
  },
  deleteCommunicationRule: (payload) => {
    return {
      type: "SETTINGS/DELETE_COMMUNICATION_RULE",
      payload,
    };
  },
  getOrderStatusList: (payload) => {
    return {
      type: "SETTINGS/GET_ORDER_STATUS_LIST",
      payload,
    };
  },
  postOrderStatus: (payload) => {
    return {
      type: "SETTINGS/POST_ORDER_STATUS",
      payload,
    };
  },
  patchOrderStatus: (payload) => {
    return {
      type: "SETTINGS/PATCH_ORDER_STATUS",
      payload,
    };
  },
  deleteOrderStatus: (payload) => {
    return {
      type: "SETTINGS/DELETE_ORDER_STATUS",
      payload,
    };
  },
  postTaskType: (payload) => {
    return {
      type: "SETTINGS/POST_TASK_TYPE",
      payload,
    };
  },
  patchTaskType: (payload) => {
    return {
      type: "SETTINGS/PATCH_TASK_TYPE",
      payload,
    };
  },
  deleteTaskType: (payload) => {
    return {
      type: "SETTINGS/DELETE_TASK_TYPE",
      payload,
    };
  },
};

// GET DRUG DATA ASYNC
function* getDrugListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.getDrugList(action?.payload);
    const { status, data } = response;
    if (status) {
      yield put(setDrugList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setDrugList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST DRUG FUNCTION
function* postDrugDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.postDrugData(action.payload);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddDrugDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddDrugDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH DRUG DATA ASYNC
function* patchDrugDataAsync(action) {
  const { drugId, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.patchDrugData(drugId, payload);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log(data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddDrugDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddDrugDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE DRUG ASYNC
function* deleteDrugAsync(action) {
  const { drugId, comesFrom } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.deleteDrug(drugId);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      yield put(setCloseAddDrugDialog(true));
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    yield put(setCloseAddDrugDialog(false));
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST CODE FUNCTION
function* postCodeDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.postCodeData(action.payload);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddCodeDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddCodeDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET CODE DATA ASYNC
function* getCodeListAsync(action) {
  const isFirstPage = (action?.payload?.pageNumber ?? 1) === 1;
  try {
    if (isFirstPage) yield put(showLoader());
    const response = yield SettingsService.getCodeList(action?.payload);
    const { status, data } = response;
    if (status) {
      yield put(isFirstPage ? setCodeList(data) : appendCodeList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    if (isFirstPage) yield put(setCodeList({}));
    console.log("err: ", error);
  } finally {
    if (isFirstPage) yield put(hideLoader());
  }
}

// PATCH CODE DATA ASYNC
function* patchCodeDataAsync(action) {
  const { codeId, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.patchCodeData(codeId, payload);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log(data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddCodeDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddCodeDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE CODE ASYNC
function* deleteCodeAsync(action) {
  const { codeId, comesFrom } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.deleteCode(codeId);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      yield put(setCloseAddCodeDialog(true));
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    yield put(setCloseAddCodeDialog(false));
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST TEMPLATE FUNCTION
function* postTemplateDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.postTemplateData(action.payload);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddTemplateDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddTemplateDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET TEMPLATE DATA ASYNC
function* getTemplateListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.getTemplateList(action?.payload);
    const { status, data } = response;
    if (status) {
      yield put(setTemplateList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setTemplateList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET TEMPLATE NAME OPTIONS ASYNC
// Lightweight background fetch used to populate the "Template Name" dropdown
// with previously-created (custom) names. No loader to avoid table flicker.
function* getTemplateNameOptionsAsync(action) {
  try {
    const response = yield SettingsService.getTemplateList({
      type: action?.payload?.type,
      pageNumber: 1,
      limit: 1000,
    });
    const { status, data } = response;
    if (status) {
      yield put(setTemplateNameOptions(data?.templates || []));
    }
  } catch (error) {
    yield put(setTemplateNameOptions([]));
    console.log("err: ", error);
  }
}

// PATCH TEMPLATE DATA ASYNC
function* patchTemplateDataAsync(action) {
  const { templateId, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.patchTemplateData(
      templateId,
      payload
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log(data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddTemplateDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddTemplateDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// UPLOAD TEMPLATE DATA ASYNC
function* uploadTemplateDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.uploadTemplateData(action.payload);
    const { status, data } = response;
    if (status) {
      const { success, summary, message, valid, invalid } = data;
      
      if (success) {
        eventEHRCustomToastMessage({
          title: message || "Templates imported successfully",
          status: "success",
        });
        yield put(setCloseAddTemplateDialog(true));
      } else {
        // If there are invalid records, show them in a dialog
        if (invalid && invalid.length > 0) {
          // Store the results in Redux state
          yield put(setTemplateImportResults({
            summary: summary || {
              totalRecords: 0,
              validRecords: 0,
              invalidRecords: invalid.length,
              createdTemplates: 0,
            },
            valid: valid || [],
            invalid: invalid || [],
            message: message || "No valid data found to import",
          }));
          // Open the results dialog
          yield put(setOpenTemplateImportResultsDialog(true));
          // Close the upload dialog
          yield put(setCloseAddTemplateDialog(true));
        } else {
          // Show summary of import results
          const summaryMessage = `Total: ${summary?.totalRecords || 0}, Valid: ${summary?.validRecords || 0}, Invalid: ${summary?.invalidRecords || 0}`;
          eventEHRCustomToastMessage({
            title: message || summaryMessage,
            status: summary?.validRecords > 0 ? "warning" : "error",
          });
          
          // Only close dialog if there are valid records
          if (summary?.validRecords > 0) {
            yield put(setCloseAddTemplateDialog(true));
          }
        }
      }
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message || "Failed to upload templates"}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST USER FUNCTION
function* postUserDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.postUserData(action.payload);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddUserDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddUserDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST USER FUNCTION
function* getAdminUsersAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.getAdminUsers(action.payload);
    const { status } = response;
    if (status) {
      const { message, adminUsers } = response?.data;
      yield put(setAdminUsersList(response?.data));
    }
  } catch (error) {
    yield put(setAdminUsersList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* patchAdminUsersDataAsync(action) {
  const { userId, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.patchAdminUsersData(userId, payload);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log(data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddUserDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddUserDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE ADMIN USER ASYNC
function* deleteAdminUserAsync(action) {
  const { id } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.deleteAdminUser(id);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log(data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddUserDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddUserDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// SEND ADMIN USER INVITATION ASYNC
function* sendAdminUserInvitationAsync(action) {
  const { id } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.sendAdminUserInvitation(id);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// SEND ADMIN USER BULK INVITATION ASYNC
function* sendAdminUserBulkInvitationAsync(action) {
  const { ids } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.sendAdminUserBulkInvitation(ids);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* getDataImportAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.getDataImportData(action.payload);

    const { status } = response;
    if (status) {
      const { message, adminUsers } = response?.data;
      yield put(getDataImport(response?.data));
    }
  } catch (error) {
    yield put(getDataImport({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* postDataImportDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.postDataImportData(action?.payload);
    console.log("Post Response", response);
    const { status } = response;

    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseDataImportData(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseDataImportData(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* patchDataImportAsync(action) {
  const { id, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.patchDataImportData(id, payload);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log(data);
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseDataImportData(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseDataImportData(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET ROLES AND RESPONSIBILITY DATA ASYNC
function* getRolesResponsibilityListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.getRolesResponsibilityList(
      action?.payload
    );
    const { status, data } = response;
    if (status) {
      yield put(setRolesResponsibilityList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setRolesResponsibilityList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST ROLES AND RESPONSIBILITY FUNCTION
function* postRolesResponsibilityDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.postRolesResponsibilityData(
      action.payload
    );
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddRolesResponsibilityDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddRolesResponsibilityDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH ROLES AND RESPONSIBILITY DATA ASYNC
function* patchRolesResponsibilityDataAsync(action) {
  const { roleId, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.patchRolesResponsibilityData(
      roleId,
      payload
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log(data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddRolesResponsibilityDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddRolesResponsibilityDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST MASTER ROLE ASYNC
function* postMasterRoleDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.postMasterRole(action.payload);
    const { status } = response;
    if (status) {
      const { message, masterRole } = response?.data || {};
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setMasterRoleCreated(masterRole));
      yield put(setCloseMasterRoleDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setMasterRoleCreated(null));
    yield put(setCloseMasterRoleDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH MASTER ROLE ASYNC
function* patchMasterRoleDataAsync(action) {
  const { masterRoleId, payload } = action?.payload || {};
  try {
    yield put(showLoader());
    const response = yield SettingsService.patchMasterRole(
      masterRoleId,
      payload
    );
    const { status } = response;
    if (status) {
      const { message } = response?.data || {};
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseMasterRoleDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseMasterRoleDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET MASTER DATA LIST ASYNC
function* getMasterDataListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.getMasterDataList(action?.payload);
    const { status, data } = response;
    if (status) {
      yield put(setMasterDataList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setMasterDataList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST MASTER DATA ASYNC
function* postMasterDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.postMasterData(action.payload);
    const { status } = response;
    if (status) {
      const { message } = response?.data || {};
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseMasterDataDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseMasterDataDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH MASTER DATA ASYNC
function* patchMasterDataAsync(action) {
  const { id, payload } = action?.payload || {};
  try {
    yield put(showLoader());
    const response = yield SettingsService.patchMasterData(id, payload);
    const { status } = response;
    if (status) {
      const { message } = response?.data || {};
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseMasterDataDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseMasterDataDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE MASTER DATA ASYNC
function* deleteMasterDataAsync(action) {
  const { id } = action?.payload || {};
  try {
    yield put(showLoader());
    const response = yield SettingsService.deleteMasterData(id);
    const { status } = response;
    if (status) {
      const { message } = response?.data || {};
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseMasterDataDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseMasterDataDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST TASK TYPE ASYNC
function* postTaskTypeAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.postMasterData(action.payload);
    const { status } = response;
    if (status) {
      eventEHRCustomToastMessage({
        title: "Task Type created successfully",
        status: "success",
      });
      yield put(setCloseMasterDataDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseMasterDataDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH TASK TYPE ASYNC
function* patchTaskTypeAsync(action) {
  const { id, payload } = action?.payload || {};
  try {
    yield put(showLoader());
    const response = yield SettingsService.patchMasterData(id, payload);
    const { status } = response;
    if (status) {
      eventEHRCustomToastMessage({
        title: "Task Type updated successfully",
        status: "success",
      });
      yield put(setCloseMasterDataDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseMasterDataDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE TASK TYPE ASYNC
function* deleteTaskTypeAsync(action) {
  const { id } = action?.payload || {};
  try {
    yield put(showLoader());
    const response = yield SettingsService.deleteMasterData(id);
    const { status } = response;
    if (status) {
      eventEHRCustomToastMessage({
        title: "Task Type deleted successfully",
        status: "success",
      });
      yield put(setCloseMasterDataDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseMasterDataDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE MASTER ROLE ASYNC
function* deleteMasterRoleAsync(action) {
  const { masterRoleId } = action?.payload || {};
  try {
    yield put(showLoader());
    const response = yield SettingsService.deleteMasterRole(masterRoleId);
    const { status } = response;
    if (status) {
      const { message } = response?.data || {};
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseMasterRoleDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseMasterRoleDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET MASTER ROLE LIST ASYNC
function* getMasterRoleListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.getMasterRoleList(action?.payload);
    const { status, data } = response;
    if (status) {
      yield put(setMasterRoleList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setMasterRoleList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET ORDER TYPE LIST ASYNC
function* getOrderTypeListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.getOrderTypeList(action?.payload);
    const { status, data } = response;
    if (status) {
      yield put(setOrderTypeList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setOrderTypeList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST ORDER TYPE ASYNC
function* postOrderTypeDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.postOrderType(action.payload);
    const { status } = response;
    if (status) {
      const { message } = response?.data || {};
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddOrderTypeDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddOrderTypeDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH ORDER TYPE ASYNC
function* patchOrderTypeDataAsync(action) {
  const { orderTypeId, payload } = action?.payload || {};
  try {
    yield put(showLoader());
    const response = yield SettingsService.patchOrderType(
      orderTypeId,
      payload
    );
    const { status } = response;
    if (status) {
      const { message } = response?.data || {};
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddOrderTypeDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddOrderTypeDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE ORDER TYPE ASYNC
function* deleteOrderTypeAsync(action) {
  const { orderTypeId } = action?.payload || {};
  try {
    yield put(showLoader());
    const response = yield SettingsService.deleteOrderType(orderTypeId);
    const { status } = response;
    if (status) {
      const { message } = response?.data || {};
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddOrderTypeDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddOrderTypeDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE ROLES AND RESPONSIBILITY ASYNC
function* deleteRolesResponsibilityAsync(action) {
  const { roleId, comesFrom } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.deleteRolesResponsibility(roleId);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      yield put(setCloseAddRolesResponsibilityDialog(true));
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    yield put(setCloseAddRolesResponsibilityDialog(false));
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* getProfileAdminUsersDataAsync(action) {
  const { id } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.getAdminUserForProfile(id);
    const { status } = response;
    if (status) {
      const { adminUser } = response?.data;
      yield put(getAdminUserProfileData(adminUser));
    }
  } catch (error) {
    yield put(getAdminUserProfileData({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* patchProfileAdminUserDataAsync(action) {
  const { id, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.patchAdminProfileData(id, payload);

    const { status } = response?.data;
    if (status) {
      const { adminUser, message } = response?.data;

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAdminUserProfileData(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAdminUserProfileData(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET COMMUNICATION RULES ASYNC
function* getCommunicationRulesAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.getCommunicationRules(action?.payload);
    const { status, data } = response;
    if (status) {
      yield put(setCommunicationRulesList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCommunicationRulesList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// CREATE COMMUNICATION RULE ASYNC
function* createCommunicationRuleAsync(action) {
  try {
    yield put(showLoader());
    const response = yield SettingsService.createCommunicationRule(action.payload);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddCommunicationRuleDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddCommunicationRuleDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET COMMUNICATION RULE BY ID ASYNC
function* getCommunicationRuleByIdAsync(action) {
  const { ruleId } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.getCommunicationRuleById(ruleId);
    const { status } = response;
    if (status) {
      const { data } = response?.data;
      yield put(setCommunicationRuleById(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCommunicationRuleById({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// UPDATE COMMUNICATION RULE ASYNC
function* updateCommunicationRuleAsync(action) {
  const { ruleId, payload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.updateCommunicationRule(ruleId, payload);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log(data);

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddCommunicationRuleDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddCommunicationRuleDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE COMMUNICATION RULE ASYNC
function* deleteCommunicationRuleAsync(action) {
  const { ruleId, comesFrom } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield SettingsService.deleteCommunicationRule(ruleId);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      yield put(setCloseAddCommunicationRuleDialog(true));
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    yield put(setCloseAddCommunicationRuleDialog(false));
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET ORDER STATUS LIST ASYNC
function* getOrderStatusListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield OrderStatusService.getOrderStatusList(action?.payload);
    const { status, data } = response;
    if (status && data?.success) {
      yield put(setOrderStatusList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setOrderStatusList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST ORDER STATUS ASYNC
function* postOrderStatusAsync(action) {
  try {
    yield put(showLoader());
    const response = yield OrderStatusService.postOrderStatus(action.payload);
    const { status, data } = response;
    if (status && data?.success) {
      const { message } = data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddOrderStatusDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddOrderStatusDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH ORDER STATUS ASYNC
function* patchOrderStatusAsync(action) {
  const { id, payload } = action?.payload || {};
  try {
    yield put(showLoader());
    const response = yield OrderStatusService.patchOrderStatus(id, payload);
    const { status, data } = response;
    if (status && data?.success) {
      const { message } = data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddOrderStatusDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddOrderStatusDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE ORDER STATUS ASYNC
function* deleteOrderStatusAsync(action) {
  const { id } = action?.payload || {};
  try {
    yield put(showLoader());
    const response = yield OrderStatusService.deleteOrderStatus(id);
    const { status, data } = response;
    if (status && data?.success) {
      const { message } = data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddOrderStatusDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddOrderStatusDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* rootSaga() {
  yield all([takeLatest(postTemplateData().type, postTemplateDataAsync)]);
  yield all([takeLatest(getTemplateList().type, getTemplateListAsync)]);
  yield all([
    takeLatest(getTemplateNameOptions().type, getTemplateNameOptionsAsync),
  ]);
  yield all([takeLatest(patchTemplateData().type, patchTemplateDataAsync)]);
  yield all([takeLatest(uploadTemplateData().type, uploadTemplateDataAsync)]);
  yield all([takeLatest(postUserData().type, postUserDataAsync)]);
  yield all([takeLatest(getAdminUsers().type, getAdminUsersAsync)]);
  yield all([takeLatest(patchAdminUsersData().type, patchAdminUsersDataAsync)]);
  yield all([takeLatest(deleteAdminUser().type, deleteAdminUserAsync)]);
  yield all([
    takeLatest(
      sendAdminUserInvitation().type,
      sendAdminUserInvitationAsync
    ),
  ]);
  yield all([
    takeLatest(
      sendAdminUserBulkInvitation().type,
      sendAdminUserBulkInvitationAsync
    ),
  ]);
  yield all([takeLatest(getDataImportList().type, getDataImportAsync)]);
  yield all([takeLatest(postCodeData().type, postCodeDataAsync)]);
  yield all([takeLatest(getCodeList().type, getCodeListAsync)]);
  yield all([takeLatest(patchCodeData().type, patchCodeDataAsync)]);
  yield all([takeLatest(deleteCode().type, deleteCodeAsync)]);
  yield all([takeLatest(postDataImport().type, postDataImportDataAsync)]);
  yield all([takeLatest(patchDataImport().type, patchDataImportAsync)]);
  yield all([takeLatest(getDrugList().type, getDrugListAsync)]);
  yield all([takeLatest(postDrugData().type, postDrugDataAsync)]);
  yield all([takeLatest(patchDrugData().type, patchDrugDataAsync)]);
  yield all([takeLatest(deleteDrug().type, deleteDrugAsync)]);
  yield all([
    takeLatest(
      getRolesResponsibilityList().type,
      getRolesResponsibilityListAsync
    ),
  ]);
  yield all([
    takeLatest(
      postRolesResponsibilityData().type,
      postRolesResponsibilityDataAsync
    ),
  ]);
  yield all([
    takeLatest(
      patchRolesResponsibilityData().type,
      patchRolesResponsibilityDataAsync
    ),
  ]);
  yield all([
    takeLatest(
      deleteRolesResponsibility().type,
      deleteRolesResponsibilityAsync
    ),
  ]);
  yield all([takeLatest(postMasterRoleData().type, postMasterRoleDataAsync)]);
  yield all([takeLatest(patchMasterRoleData().type, patchMasterRoleDataAsync)]);
  yield all([takeLatest(deleteMasterRole().type, deleteMasterRoleAsync)]);
  yield all([takeLatest(getMasterRoleList().type, getMasterRoleListAsync)]);
  yield all([takeLatest(getMasterDataList().type, getMasterDataListAsync)]);
  yield all([takeLatest(postMasterData().type, postMasterDataAsync)]);
  yield all([takeLatest(patchMasterData().type, patchMasterDataAsync)]);
  yield all([takeLatest(deleteMasterData().type, deleteMasterDataAsync)]);
  yield all([takeLatest(getOrderTypeList().type, getOrderTypeListAsync)]);
  yield all([takeLatest(postOrderTypeData().type, postOrderTypeDataAsync)]);
  yield all([takeLatest(patchOrderTypeData().type, patchOrderTypeDataAsync)]);
  yield all([takeLatest(deleteOrderType().type, deleteOrderTypeAsync)]);
  yield all([takeLatest(getProfileData().type, getProfileAdminUsersDataAsync)]);
  yield all([
    takeLatest(patchProfileData().type, patchProfileAdminUserDataAsync),
  ]);
  yield all([takeLatest(getCommunicationRules().type, getCommunicationRulesAsync)]);
  yield all([takeLatest(createCommunicationRule().type, createCommunicationRuleAsync)]);
  yield all([takeLatest(getCommunicationRuleById().type, getCommunicationRuleByIdAsync)]);
  yield all([takeLatest(updateCommunicationRule().type, updateCommunicationRuleAsync)]);
  yield all([takeLatest(deleteCommunicationRule().type, deleteCommunicationRuleAsync)]);
  yield all([takeLatest(getOrderStatusList().type, getOrderStatusListAsync)]);
  yield all([takeLatest(postOrderStatus().type, postOrderStatusAsync)]);
  yield all([takeLatest(patchOrderStatus().type, patchOrderStatusAsync)]);
  yield all([takeLatest(deleteOrderStatus().type, deleteOrderStatusAsync)]);
  yield all([takeLatest(postTaskType().type, postTaskTypeAsync)]);
  yield all([takeLatest(patchTaskType().type, patchTaskTypeAsync)]);
  yield all([takeLatest(deleteTaskType().type, deleteTaskTypeAsync)]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
